/* src/components/chart-signal-matrix/chart-signal-matrix.component.scss */
:host {
  display: block;
}
.chart-signal-matrix {
  position: relative;
  z-index: 1;
  height: var(--chart-signal-matrix-height, 30vh);
  max-height: var(--chart-signal-matrix-max-height, 26rem);
  background:
    linear-gradient(
      60deg,
      var(--vwui-color-success) 10%,
      var(--vwui-color-warning) 50%,
      var(--vwui-color-error) 90%);
  border-radius: var(--vwui--radius--md);
  -webkit-user-select: none;
  user-select: none;
}
.chart-signal-matrix--signal-reversed {
  background:
    linear-gradient(
      240deg,
      var(--vwui-color-success) 10%,
      var(--vwui-color-warning) 50%,
      var(--vwui-color-error) 90%);
}
.chart-signal-matrix--large {
  height: var(--chart-signal-matrix-height-large, 45vh);
  max-height: var(--chart-signal-matrix-max-height-large, 39rem);
}
.chart-signal-matrix__wrapper {
  position: absolute;
  z-index: 1;
  top: 15px;
  right: 15px;
  bottom: 15px;
  left: 15px;
}
.chart-signal-matrix__wrapper--horizontal-title {
  top: 60px;
  bottom: 60px;
}
.chart-signal-matrix__wrapper--vertical-title {
  right: 60px;
  left: 60px;
}
.chart-signal-matrix__target {
  position: absolute;
  z-index: 3;
  width: 15px;
  height: 15px;
  top: 100%;
  left: 0;
  border-radius: 15px;
  box-shadow: 0 0 0 6px rgba(255, 255, 255, 0.4), 0 0 45px 0 rgba(0, 0, 0, 0.7);
  transform: translateX(-50%) translateY(-50%);
  transition: all 0.4s cubic-bezier(0.19, 1, 0.22, 1);
}
.chart-signal-matrix__target-dot {
  position: absolute;
  top: 2px;
  left: 2px;
  background: #fff;
  width: 11px;
  height: 11px;
  border-radius: 11px;
}
@media print {
  .chart-signal-matrix__target {
    box-shadow: 0 0 0 6px rgba(255, 255, 255, 0.4);
  }
}
.chart-signal-matrix__dots {
  position: absolute;
  z-index: 3;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.chart-signal-matrix__dot {
  position: absolute;
  top: 2px;
  left: 2px;
  background: #fff;
  width: 11px;
  height: 11px;
  border-radius: 11px;
  transform: translateX(-50%) translateY(-50%);
}
.chart-signal-matrix__dot vwui-tooltip {
  display: inline-block;
  vertical-align: top;
  width: 11px;
  height: 11px;
}
.chart-signal-matrix__dot--inactive {
  background: #a0a0a0;
}
.chart-signal-matrix__dotsize {
  position: absolute;
  width: 15px;
  height: 15px;
  top: 0;
  left: 0;
  line-height: 15px;
  color: rgba(0, 0, 0, 0);
  -webkit-user-select: none;
  user-select: none;
}
.chart-signal-matrix__target-line-horizontal,
.chart-signal-matrix__target-line-vertical {
  position: absolute;
  z-index: 2;
  transition: all 0.4s cubic-bezier(0.19, 1, 0.22, 1);
}
.chart-signal-matrix__target-line-horizontal {
  left: 15px;
  right: -15px;
  border-top: 1px solid rgba(255, 255, 255, 0.3);
}
.chart-signal-matrix__target-line-vertical {
  top: -15px;
  bottom: 15px;
  border-left: 1px solid rgba(255, 255, 255, 0.3);
}
.chart-signal-matrix__label-horizontal,
.chart-signal-matrix__label-vertical {
  position: absolute;
  z-index: 1;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.6);
  transform: translateX(-50%) translateY(-50%);
  line-height: 0;
  font-size: 11px;
  white-space: nowrap;
}
.chart-signal-matrix__label-horizontal--selected,
.chart-signal-matrix__label-vertical--selected {
  color: #fff;
}
.chart-signal-matrix__label-horizontal {
  bottom: 0;
}
.chart-signal-matrix__label-vertical {
  left: 0;
}
.chart-signal-matrix__label-horizontal-title,
.chart-signal-matrix__label-vertical-title {
  position: absolute;
  z-index: 1;
  font-weight: 500;
  color: var(--vwui-color-light);
  text-align: center;
  transform-origin: 50% 50%;
  line-height: 2rem;
  font-size: 11px;
}
.chart-signal-matrix__label-horizontal-title {
  bottom: -3rem;
  left: 50%;
  transform: translateX(-50%);
}
.chart-signal-matrix__label-vertical-title {
  left: -2rem;
  top: calc(50% - 1rem);
  transform: translateX(-50%) rotate(-90deg);
}
/*# sourceMappingURL=chart-signal-matrix.component-E4A3VJUW.css.map */
